import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'gradient',
    standalone: false
})
export class GradientPipe implements PipeTransform {
    public transform(deg: number, ...params: string[]): string {
        // Ensure params are multiple of 2
        if (params.length % 2 !== 0) throw new Error('Uneven gradient params found.');

        // Parse params to colors
        const colors = params.reduce((colors, p, i) => {
            if (i % 2 !== 0) colors[colors.length - 1][1] = p;
            else colors.push([p, '']);
            return colors;
        }, [] as [string, string][]);

        // Generate linear-gradient
        return `linear-gradient(${deg}deg, ${colors.map(c => `${c[0]} ${c[1]}`).join(', ')})`;
    }
}
